import { render, staticRenderFns } from "./CompanyLocation.vue?vue&type=template&id=979f5e14"
import script from "./CompanyLocation.vue?vue&type=script&lang=js"
export * from "./CompanyLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports